import { CSSProperties, useMemo } from 'react'

import { FormStatus, ObservationStatus, TaskStatus } from '@types'

import pattern from '@/assets/images/marker-background-pattern.png'

import { Marker } from '../type'

import { BASE_MARKER_STYLES, MARKER_COLORS } from '../constants'

export const useMarkerStyles = (isSelected: boolean, isHover: boolean, marker: Marker): CSSProperties => {
  const status: ObservationStatus | FormStatus | TaskStatus | undefined = marker.data?.status

  const isValidated = [
    ObservationStatus.StatusValidatedByAdmin,
    ObservationStatus.StatusValidatedByCustomer,
    ObservationStatus.StatusValidatedByReader,
    FormStatus.StatusDone,
    TaskStatus.StatusDone,
  ].includes(status as ObservationStatus | FormStatus | TaskStatus)

  return useMemo(() => {
    return {
      ...BASE_MARKER_STYLES,
      top: `calc(${marker.y}% - 28px) `,
      left: `calc(${marker.x}% - 28px)`,
      boxShadow: isSelected
        ? '0 0 0 2px #49536F'
        : '0px 1px 2px -1px rgba(0, 0, 0, 0.1), 0px 2px 3px 0px rgba(0, 0, 0, 0.1)',
      zIndex: isSelected ? 2 : 1,
      filter: isHover ? 'brightness(0.95)' : 'none',
      ...(isValidated
        ? {
            backgroundBlendMode: 'plus-darker',
            background: `url(${pattern}) #eceef2 repeat`,
          }
        : {
            backgroundColor: marker.data?.trade?.color || MARKER_COLORS[marker.type],
          }),
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marker.x, marker.y, isHover, isSelected, marker.data?.trade?.color, marker.type, marker.data?.status])
}
